import React from 'react';
import PropTypes from 'prop-types';

import styles from './Card.module.scss';

const Card = ({
  title,
  titleAccent,
  leftAdditional,
  subtitle,
  children,
  headerAdditional,
  hasPadding,
  hasScroll,
  additionalStyles = '',
}) => {
  const hasTitle = Boolean(title || titleAccent);
  const hasHeader = Boolean(
    title || titleAccent || subtitle || leftAdditional || headerAdditional
  );

  const header = (
    <header className={styles['header']}>
      {hasTitle && (
        <h2 className={styles['header-title']}>
          {title}
          <span className={styles['header-title-accent']}>{titleAccent}</span>
        </h2>
      )}
      {subtitle ? (
        <h3 className={styles['header-subtitle']}>{subtitle}</h3>
      ) : (
        ''
      )}
      {leftAdditional && (
        <div className={styles['header-left-additional']}>{leftAdditional}</div>
      )}
      <div className={styles['header-additional']}>{headerAdditional}</div>
    </header>
  );

  return (
    <section className={`${styles['card']} ${additionalStyles}`}>
      {/* We might not always want to have a header here, you see... */}
      {hasHeader ? header : ''}

      <div
        className={`${styles['body']} ${
          hasPadding ? '' : styles['no-padding']
        } ${hasScroll ? 'custom-scroll' : ''}`}
      >
        {children}
      </div>
    </section>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  titleAccent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  leftAdditional: PropTypes.node,
  subtitle: PropTypes.string,
  headerAdditional: PropTypes.node,
  hasPadding: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  additionalStyles: PropTypes.string,
  hasScroll: PropTypes.bool,
};

Card.defaultProps = {
  hasPadding: false,
};

export default Card;
